import { useEffect } from 'react';

const useFavicon = (href: string) => {
  useEffect(() => {
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement('link');
    link.setAttribute('type', 'image/png');
    link.setAttribute('rel', 'icon');
    link.setAttribute('href', href);
    document.getElementsByTagName('head')[0]?.appendChild(link);
  }, [href]);
};

export default useFavicon;
